export default __webpack_public_path__ + "static/media/guardian.f6a76ac1.png";